import React from 'react';
import { Route } from 'react-router-dom';
import UnexpectedError from '../common/components/UnexpectedError';
import { invalidateTokens } from '../common/services/security/userAuthService';
import authorizationService from '../common/services/security/authorizationService';

function UnauthenticatedRoute() {
  return (
    <Route
      exact
      path="/unauthenticated"
      render={() => {
        if (!authorizationService.hasValidToken()) {
          invalidateTokens();
          return (
            <UnexpectedError
              statusCode="401"
              description="You are not authenticated; please log in again."
              text="Return to login"
            />
          );
        }
        return (
          <UnexpectedError statusCode="404" description="Page Not Found." />
        );
      }}
    />
  );
}

export default UnauthenticatedRoute;
